module.exports = __webpack_public_path__ + "static/media/short-line.06d9c149.svg";